import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import headingStyles from "./headingStyles"

const { colors, breakPoints: { screenQuery } } = theme

const H8 = styled.h6(headingStyles, `
  font-size: 16px;
  line-height: 19px;
  ${screenQuery.large}{
    font-size: 14px;
    line-height: 17px;
  }
  ${screenQuery.small}{
    font-size: 12px;
    line-height: 14px;
  }
`)

export default ({
  children,
  ...props
}) => (
    <H8
      {...props}
    >
      {children}
    </H8>
  )
